/* @flow */

import { changeTitle, changeParagraph } from '@website/components/CommonActions'

export default { changeTitle, changeParagraph }
